import { createContext } from "react";

import type { FooterTranslations } from "./FooterTranslationProvider";

export const footerProvider = createContext<FooterTranslations | null>(null);
